// extracted by mini-css-extract-plugin
export default {"Container":"ConfigurationModal_Container__ZH+mQ","SelectDropdown":"ConfigurationModal_SelectDropdown__isDkB","Footer":"ConfigurationModal_Footer__NsjFY"};